<div class="toast {{infoType}}">
  <img class="valid-info" src="assets/custom_svg/valid.svg" alt="" *ngIf="infoType == 'info'">
  <img class="valid-alert" src="assets/custom_svg/panneau.svg" alt="" *ngIf="infoType == 'alert'">
  <div class="toast-txt">
    <h6>Information</h6>
    <p>{{message}}</p>
  </div>
  <div class="cross" (click)="dismiss()">
    <img src="assets/custom_svg/cross.svg" alt="">
  </div>
</div>
